<template>
    <el-date-picker v-model="newValue" :type="type" @change="change" :value-format="valueFormat" :format="format" 
       :placeholder="getStartEndPlaceholder()" :start-placeholder="getStartEndPlaceholder('start')" :clearable="clearable"
       :end-placeholder="getStartEndPlaceholder('end')" :style="style">
    </el-date-picker>
</template>

<script>
import { i18nConfig } from '@/utils/ruoyi'
import { ref, reactive, toRefs, onMounted, watch } from 'vue';
export default {
    name:"gljy-date-picker",
    emits:["update:value", "update:startDate", "update:endDate", "update:startDateString", "update:endDateString", "change"],
    props:{
        // "year", "month", "date", "datetime", "week", "datetimerange", "daterange"
        style: {
            type: [String, Object],
            default: "width: 100%"
        },
        type: {
            type: String,
            default: "date"
        },
        // // 是否显示时间
        showTime:{
            type: Boolean,
            default: false
        },
        value:{
            type:[String, Array]
        },
        startDate: {
            type: String
        },
        endDate: {
            type: String
        },
        valueFormat:{
            type: String,
            default: "YYYY-MM-DD"
        },
        format:{
            type: String,
            default: "YYYY-MM-DD"
        },
        // // 提示文字
        placeholder: {
            type: [String, Array]
        },
        clearable: {
            type: Boolean,
            default: true
        },
        startPlaceholder: String,
        endPlaceholder: String
    },  
    setup(props, context){
        const datas = reactive({
            newValue: undefined,
        })

        onMounted(() => {
            datas.newValue = props.value;
        })

        watch(() => props.value, (value) => {
            datas.newValue = props.value;
        })

        const methods = {
            getStartEndPlaceholder(startOrEnd){
                const type = props.type;
                if(type == "datetimerange" || type == "daterange"){
                    if(typeof props.placeholder === "string") return undefined;
                    if(startOrEnd == "start"){
                        if(props.startPlaceholder){
                            return i18nConfig(props.startPlaceholder);
                        }
                        if(props.placeholder?.length == 0) return ""; 
                        return i18nConfig(props.placeholder[0]);
                    }else if(startOrEnd == "end"){
                        if(props.endPlaceholder){
                            return i18nConfig(props.endPlaceholder);
                        }
                        if(props.placeholder?.length < 1) return "";
                        return i18nConfig(props.placeholder[1]);
                    }
                }else{
                    return i18nConfig(props.placeholder);
                }
            },
            change(date){
                if(props.type == "datetimerange" || props.type == "daterange"){
                    context.emit("update:startDate", date && date.length > 0 ? date[0] : undefined);
                    context.emit("update:endDate", date && date.length > 0 ? date[1] : undefined);
                }
                context.emit("update:value", date);
                context.emit("change", date);
            }
        }

        return {
            ...toRefs(datas),
            ...methods
        }
    }
}
</script>

<style>

</style>